<template>
    <footer class="footer__section mt-5">
        <section>
            <div class="container-fluid" v-if="manageables">
                <div class="row">
                    <div class="col-sm-3 col-12 d-flex justify-content-center align-items-start mt-2 div__info">
                        <img src="/logo-white.png" alt="">
                    </div>
                    <div class="col-sm-3 col-12 d-flex justify-content-center align-items-start mt-2 div__info">
                        <p> Empresa Mexicana con 40 años de trayectoria de éxito en la promoción de desarrollos
                            inmobiliarios y de infraestructura, a través de proyectos vanguardistas e innovadores
                            que han contribuido directamente al desarrollo de San Luis Potosí y México.</p>
                    </div>
                    <!--  <div class="col-sm-3 col-12">
                                <ul class="link__list">
                                    <li class="link__list-title">De interés</li>
                                    <li>enlace</li>
                                    <li>enlace</li>
                                    <li>enlace</li>
                                    <li>enlace</li>
                                </ul>
                            </div> -->
                    <div class="col-sm-3 col-12 d-flex justify-content-center align-items-start mt-2"
                        v-for="manageable in manageables" :key="manageable.id">
                        <ul class="link__list">
                            <li class="link__list-title">Redes sociales</li>
                            <li>Síguenos</li>
                            <li>
                                <a target="_blank" :href="manageable.facebook">
                                    <small>Facebook</small>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" :href="manageable.twitter">
                                    <small>Twitter</small>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" :href="manageable.instagram">
                                    <small>Instagram</small>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3 col-12 d-flex justify-content-center align-items-start mt-2">
                        <ul class="link__list">
                            <li class="link__list-title">META</li>
                            <div v-if="documents">
                                <div class="link__list" v-for="document in documents" :key="document.id">
                                    <a target="_blank" class="text-white font-weight-bold ps-1 mb-0 icon-move-right mt-auto"
                                        :href="document.file_url" v-if="document.title === 'Política de privacidad'">
                                        <span>{{ document.title }} </span>
                                    </a>
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <router-link class="row" to="/privacy-policies">
                <div class="footer__terms">
                    <div class="container">
                        <div class="row justify-content-center ">
                            <div class="col-sm-10">
                                META. Todos los derechos reservados
                            </div>
                        </div>
                    </div>
                </div>
            </router-link>
        </section>
    </footer>
</template>

<script>

export default {
    name: "FooterSection",
    data() {
        return {
            manageables: undefined,
            documents: undefined,
        };
    },
    methods: {
        document() {
            this.plain
                .get(`/documents`)
                .then((response) => {
                    if (response.data.length !== 0) {
                        this.documents = response.data;
                    } else {
                        this.documents = [];
                    }
                    // console.log(this.documents);
                })
                .catch((err) => {
                    this.documents = [];
                    console.log(err);
                });
        },
    },
    created() {
        this.document();
        this.plain
            .get(`/manageables`)
            .then((response) => {
                if (response.data.length !== 0) this.manageables = response.data;
                else this.manageables = [];
                // console.log(this.manageables)
            })
            .catch((err) => {
                this.manageables = [];
                console.log(err);
            });
    },
}

</script>

<style scoped lang="scss">
$primaryColor: #0153a2;

.footer__section {
    position: relative;
    background-color: $primaryColor;
    background-image: url('/wave-footer.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 40px;

    .div__info {

        img {
            max-width: 200px;
        }

        p {
            color: #fff;
            font-size: 14px;
        }
    }

    .link__list {

        color: #fff;
        list-style-type: none;

        li {
            margin-bottom: 10px;
            font-size: 14px;

            &.link__list-title {
                font-weight: 600;
                font-size: 17px;
            }
        }

        small {
            color: white;
        }

    }

    .footer__terms {
        width: 100%;
        height: 7vh;
        bottom: 0;
        color: #fff;
        font-size: 11px;
        background-color: #003A71;

        display: flex;
        text-align: center;
        flex-direction: column;
        justify-content: center;
    }

}

.justify-content-center {
    justify-content: center;
}

.align-items-center {
    align-items: center;
}
</style>